<template>
  <div v-if="order" class="component-order-state">

    <StepCancelled v-if="order.state === 'CANCELLED'">Vaše objednávka byla zrušena.</StepCancelled>

    <StepNotPaid v-if="order.state === 'PENDING_PAYMENT'">Vaše objednávka čeká na úhradu.</StepNotPaid>

    <StepWaiting v-if="isStep1Waiting">Vaše objednávka byla odeslána.</StepWaiting>
    <StepCurrent v-else-if="isStep1Current">Vaše objednávka byla odeslána.</StepCurrent>
    <StepFinished v-else-if="isStep1Finished">Vaše objednávka byla odeslána.</StepFinished>

    <StepWaiting v-if="isStep2Waiting">Obsluha zaznamenala vaši objednávku.</StepWaiting>
    <StepCurrent v-else-if="isStep2Current">Obsluha zaznamenala vaši objednávku.</StepCurrent>
    <StepFinished v-else-if="isStep2Finished">Obsluha zaznamenala vaši objednávku.</StepFinished>

    <template v-if="order.order_delivery_type.is_takeaway">
      <StepWaiting v-if="isStep3Waiting">Jídlo je připraveno k vyzvednutí.</StepWaiting>
      <StepCurrent v-else-if="isStep3aCurrent">Jídlo je připraveno k vyzvednutí.</StepCurrent>
      <StepFinished v-else-if="isStep3Finished">Jídlo je připraveno k vyzvednutí.</StepFinished>
    </template>

    <template v-if="order.order_delivery_type.is_delivery">
        <StepWaiting v-if="isStep3Waiting">Jídlo je připraveno k rozvozu.</StepWaiting>
        <StepCurrent v-else-if="isStep3bCurrent">Jídlo je připraveno k rozvozu.</StepCurrent>
        <StepFinished v-else-if="isStep3Finished">Jídlo je připraveno k rozvozu.</StepFinished>

        <StepWaiting v-if="isStep4Waiting">Jídlo je na cestě.</StepWaiting>
        <StepCurrent v-else-if="isStep4Current">Jídlo je na cestě.</StepCurrent>
        <StepFinished v-else-if="isStep4Finished">Jídlo je na cestě.</StepFinished>
    </template>

    <template v-if="order.order_delivery_type.is_takeaway">
        <StepWaiting v-if="isStep5Waiting">Objednávka je vyřízena.</StepWaiting>
        <StepCurrent v-else-if="isStep5Current">Objednávka je vyřízena.</StepCurrent>
    </template>
    <template v-else-if="order.order_delivery_type.is_takeaway">
        <StepWaiting v-if="isStep5Waiting">Objednávka je vyřízena.</StepWaiting>
        <StepCurrent v-else-if="isStep5Current">Objednávka je vyřízena.</StepCurrent>
    </template>
    <template v-else>
        <StepWaiting v-if="isStep5Waiting">Objednávka je uzavřena.</StepWaiting>
        <StepCurrent v-else-if="isStep5Current">Objednávka je uzavřena.</StepCurrent>
    </template>

  </div>
</template>

<script>
import orderGetters from "../../../store/web/order/getter-types";
import StepCurrent from "./StepCurrent";
import StepFinished from "./StepFinished";
import StepWaiting from "./StepWaiting";
import StepCancelled from "./StepCancelled";
import StepNotPaid from "./StepNotPaid";

export default {
  components: {StepNotPaid, StepCancelled, StepWaiting, StepFinished, StepCurrent},
  computed: {
    order () {
      return this.$store.getters['order/' + orderGetters.GET_ORDER];
    },
    isStep1Waiting () {
      return [].includes(this.order.state);
    },
    isStep1Current () {
      return ['NEW'].includes(this.order.state);
    },
    isStep1Finished () {
      return ['CONFIRMED', 'READY_TO_PICKUP', 'READY_TO_DELIVERY', 'ON_DELIVERY', 'CLOSED'].includes(this.order.state);
    },
    isStep2Waiting () {
      return ['NEW'].includes(this.order.state);
    },
    isStep2Current () {
      return ['CONFIRMED'].includes(this.order.state);
    },
    isStep2Finished () {
      return ['READY_TO_PICKUP', 'READY_TO_DELIVERY', 'ON_DELIVERY', 'CLOSED'].includes(this.order.state);
    },
    isStep3Waiting () {
      return ['NEW', 'CONFIRMED'].includes(this.order.state);
    },
    isStep3aCurrent () {
      return ['READY_TO_PICKUP'].includes(this.order.state);
    },
    isStep3bCurrent () {
      return ['READY_TO_DELIVERY'].includes(this.order.state);
    },
    isStep3Finished () {
      return ['CLOSED', 'ON_DELIVERY'].includes(this.order.state);
    },
    isStep4Waiting () {
      return ['NEW', 'CONFIRMED', 'READY_TO_PICKUP', 'READY_TO_DELIVERY'].includes(this.order.state);
    },
    isStep4Current () {
      return ['ON_DELIVERY'].includes(this.order.state);
    },
    isStep4Finished () {
      return ['CLOSED'].includes(this.order.state);
    },
    isStep5Waiting () {
      return ['NEW', 'CONFIRMED', 'READY_TO_PICKUP', 'READY_TO_DELIVERY', 'ON_DELIVERY'].includes(this.order.state);
    },
    isStep5Current () {
      return ['CLOSED'].includes(this.order.state);
    },
  }
}
</script>

<style lang="sass">
  .component-order-state__tag-container
    text-align: center
    width: 3.5rem
</style>
